var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTileImg3({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 200,
    viewBox: "0 0 200 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_1_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "rectangle-blue",
    x: 100,
    y: 100,
    width: 99,
    height: 99,
    fill: "#67B9FF",
    stroke: "#7F7F7F",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    id: "rectangle-white",
    x: 1,
    y: 1,
    width: 99,
    height: 99,
    stroke: "#818181",
    strokeWidth: 2
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 200,
    height: 200,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTileImg3);
export default __webpack_public_path__ + "static/media/tile_img_3.299698361da3e2ae95dac5b406d20587.svg";
export { ForwardRef as ReactComponent };